// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".restaurant-address[data-v-30f2df8a],.restaurant-opening-hours[data-v-30f2df8a],.restaurant-phone-number[data-v-30f2df8a],.view-menu-button[data-v-30f2df8a]{margin-bottom:10px}.view-menu-button[data-v-30f2df8a]{min-width:160px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
